import * as React from "react";

export const bold = (string: string) => {
    return (<strong style={{fontFamily: "OrchardCircularBlock"}}>{string}</strong>);
};